/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RoofTrimVariation {
    Charlotte = 1,
    Claire = 2,
    Zoey = 3,
    Judith = 4,
}
